import { ref } from 'vue'

export const LS_KEY = 'wc-dont-show-anymore-queue-services-notification'

export const isHiddenQueueServicesNotification = ref(localStorage.getItem(LS_KEY) ?? false)

export const hideQueueServicesNotification = (dontShowAnymore: boolean) => {
  isHiddenQueueServicesNotification.value = true

  if (dontShowAnymore) {
    localStorage.setItem(LS_KEY, 'true')
  }
}

export const showQueueServicesNotification = () => {
  isHiddenQueueServicesNotification.value = false

  localStorage.removeItem(LS_KEY)
}

export const isCallQueuesSettingsVisible = ref(false)
